// Détecte un bundle obsolète (PWA installée / cache navigateur) : compare le script main.*.js chargé à celui de l'index.html servi.
// Au démarrage (startup=true) → rechargement unique. Ensuite → jamais de reload automatique : événement "sanitdocs:new-version" → bandeau « Actualiser ».
let unsaved = false;
export const setUnsavedChanges = (v) => { unsaved = !!v; };
export const hasUnsavedChanges = () => unsaved;
const typing = () => ["INPUT", "TEXTAREA", "SELECT"].includes(document.activeElement?.tagName);

export function checkBuildVersion({ startup = false } = {}) {
  if (process.env.NODE_ENV !== "production") return;
  const current = [...document.scripts].map((s) => s.src).find((s) => /\/static\/js\/main\.[a-z0-9]+\.js/.test(s));
  if (!current) return;
  fetch(`/index.html?_=${Date.now()}`, { cache: "no-store" }).then((r) => (r.ok ? r.text() : "")).then((html) => {
    const m = html.match(/\/static\/js\/main\.[a-z0-9]+\.js/);
    if (!m || current.endsWith(m[0])) return;
    if (startup && !typing() && !unsaved && sessionStorage.getItem("sanitdocs:reloaded-for") !== m[0]) {
      sessionStorage.setItem("sanitdocs:reloaded-for", m[0]);
      window.location.reload();
      return;
    }
    window.dispatchEvent(new CustomEvent("sanitdocs:new-version", { detail: m[0] }));
  }).catch(() => {});
}
